module.exports = __webpack_public_path__ + "components/media-kit/static/alert-desktop-136c42fd0958b0698a53c30507df610f.png";